<template>
  <Page>
    <div class="page-error-container">
      <EmptyMessage>
        <span slot="icon" class="icon">
          <i class="fas fa-exclamation-circle"></i>
        </span>
        <h3>ไม่พบหน้านี้</h3>
        <p>ลองตรวจสอบ URL หรือติดต่อผู้ดูแลระบบ</p>
        <router-link :to="'/'"
          class="btn btn-light btn-lg mt-4">
          กลับสู่หน้าหลัก
        </router-link>
        <span slot="code" class="code">
          Code : 404
        </span>
      </EmptyMessage>
    </div>
  </Page>
</template>

<script>
import Page from '@/layouts/Page.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  components: {
    Page,
    EmptyMessage,
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.page-error-container {
  height: 80vh;

  display: flex;
  align-items: center;
}
</style>
